export default __webpack_public_path__ + "static/media/expressHover.fa2e269c.svg";